import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';
import ModelDataSourcePropertyBase from "./ModelDataSourcePropertyBase";

export default class Model extends ModelDataSourcePropertyBase {

    fetchParamsExpression = new PropertyDescriptor(`data = {
    mode:"cors",
    credentials:"omit"
}`, '高级参数', "高级", "js", "#anticon-Documentation", {
        description: '为网络请求（Fetch）配置高级参数',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    resultsExpression = new PropertyDescriptor(`data = data.results.map(c => {
    return {
        姓名: c.name.first + " " + c.name.last,
        年龄: c.dob.age,
        注册时长: c.registered.age,
        注册时年龄: c.registered.age - c.dob.age,
        ...c,
    };
});`, '返回值', "高级", "js", "#anticon-Documentation", {
        description: '使用 Javascript 脚本对网络请求的返回结果进行再次处理',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    getFetchParams(opts = {}) {
        if (!opts.runScript)
            return null;

        return opts.runScript(this.fetchParamsExpression, undefined, undefined, undefined, { throwException: true });
    }

    getResults(data, opts = {}) {
        if (!this.resultsExpression)
            return data;

        const result = opts.runScript(this.resultsExpression, data, undefined, { data, lastData: opts.lastData, args: opts.data }, { throwException: true });
        return result === undefined ? data : result;
    }

    toString() {
        return `设置`;
    }
}
